// @flow

import React from "react";
import style from "./style.module.scss";
import { Favourite, SocialShare, Print } from "@components";

type Props = {
    property: *,
};

const PropertyDetailsHeader = ({ property }: Props) => {
    return (
        <div className={style.propertyDetailsHeader}>
            <div className={style.options}>
                <Favourite id={property.api_id} />
                <Print propertyId={property.id} />
                <SocialShare
                    propertyTitle={
                        property.title || property.subType || property.type
                    }
                    propertyId={property.id}
                />
            </div>
        </div>
    );
};
export default PropertyDetailsHeader;
